import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useGenerateBotCodeMutation,
} from '../slices/usersApiSlice';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import ListContainer from '../components/ListContainer';
import UserProfile from '../components/UserProfile';
import Alerton from '../components/Alerton';

const ProfileScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const { data, refetch, isLoading, isError, error } = useGetProfileQuery();
  const [updateProfile] = useUpdateProfileMutation();
  // ДОБАВЛЕНО: Мутация для генерации кода
  const [generateBotCode, { isLoading: isGeneratingCode }] =
    useGenerateBotCodeMutation();

  const [message, setMessage] = useState('');
  const handleCloseMessage = () => {
    setMessage('');
  };
  const goBack = () => {
    if (userInfo?.isAdmin && !userInfo?.readOnly) {
      navigate({ pathname: '/users' }, { state: { refetch: true } });
    } else {
      navigate('/projects/v2/');
    }
  };
  const submitHandler = async (
    event,
    loginInput,
    nameInput,
    passwordInput,
  ) => {
    event.preventDefault();
    // Профиль сохраняет личные данные; полномочия меняются в карточке пользователя.
    const data = {
      login: loginInput,
      name: nameInput,
      password: passwordInput,
    };
    try {
      await updateProfile(data).unwrap();
      refetch();
      if (userInfo?.isAdmin && !userInfo?.readOnly) {
        navigate({ pathname: '/users' }, { state: { refetch: true } });
      } else {
        setMessage('Данные сохранены');
      }
    } catch (error) {
      setMessage(
        error?.data?.message || error?.message || error?.error || error,
      );
    }
  };

  // ДОБАВЛЕНО: Обработчик клика "Подключить бота"
  const handleGenerateBotCode = async () => {
    try {
      await generateBotCode().unwrap();
      refetch(); // Перезапрашиваем профиль, чтобы получить сгенерированный код
      setMessage('Код для бота успешно сгенерирован');
    } catch (error) {
      console.error('Ошибка генерации кода для бота:', error);
      setMessage(error?.data?.message || 'Ошибка генерации кода');
    }
  };

  if (isLoading) {
    return <CircularProgress />;
  } else if (isError) {
    return (
      <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
    );
  }

  return (
    <>
      <ListContainer goBack={goBack} title={data.name} addable={false}>
        <Box
          sx={{
            maxWidth: 550,
            px: 0,
            py: 1,
            //py: '20px',
            width: '100%',
          }}
        >
          <UserProfile
            data={data}
            canManageAccess={false}
            submitHandler={submitHandler}
            userInfo={userInfo}
            // ПРОКИДЫВАЕМ НОВЫЕ ПРОПСЫ:
            handleGenerateBotCode={handleGenerateBotCode}
            isGeneratingCode={isGeneratingCode}
          />
        </Box>
      </ListContainer>
      <Alerton message={message} handleCloseMessage={handleCloseMessage} />
    </>
  );
};

export default ProfileScreen;
